import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PortalEndCustomer } from '../../_models/portal/interfaces';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '../../_services/notification.service';
import { UpdateCustomerContactDetailsComponent } from 'src/app/features/portal-management/components/update-customer-contact-details/update-customer-contact-details.component';
import { AddSubscriptionDialogComponent } from 'src/app/features/portal-management/components/add-subscription-dialog/add-subscription-dialog.component';
import { PortalManagementCustomersService } from 'src/app/features/portal/_services/management/portal-management-customers.service';

@Component({
  selector: 'share-customer-action-bar',
  templateUrl: './share-customer-action-bar.component.html',
  styleUrls: ['./share-customer-action-bar.component.scss']
})
export class ShareCustomerActionBarComponent implements OnInit {
  @Input() customer: PortalEndCustomer | undefined;
  @Input() onRefresh!: () => void;
  @Input() showHotspotLookup: boolean = false;
  @Input() hideContactDetails: boolean = false;
  @Output() hotspotLookupRequested = new EventEmitter<void>();

  enablingCustomer = false;

  constructor(
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private pmcs: PortalManagementCustomersService,
    public ns: NotificationService
  ) {}

  ngOnInit(): void {}

  showCustomerUpdateContactDetails(rowData: any, $event: Event) {
    const ref = this.dialogService.open(UpdateCustomerContactDetailsComponent, {
      data: {
        customer: rowData
      },
      modal: true,
      showHeader: true,
      header: 'Update Customer Contact Details',
      width: '60%'
    });

    ref.onClose.subscribe((res) => {
      console.log('Dialog closed', res);
      this.onRefresh();
    });
  }

  showAddSubscriptionDialog() {
    const ref = this.dialogService.open(AddSubscriptionDialogComponent, {
      data: {
        portalEndCustomerId: this.customer?.id
      },
      modal: true,
      showHeader: true,
      header: 'Add Subscription',
      width: '60%'
    });

    ref.onClose.subscribe((res) => {
      if (res) {
        this.onRefresh();
      }
    });
  }

  confirmEnableCustomer() {
    this.confirmationService.confirm({
      message: `Are you sure you want to enable ${this.customer?.first_name} ${this.customer?.last_name}?`,
      header: 'Enable Customer',
      icon: 'pi pi-user-plus',
      accept: () => {
        this.enablingCustomer = true;
        this.pmcs.enablePortalCustomer(this.customer!.id!).subscribe({
          next: () => {
            this.ns.showSuccess('Success', 'Customer enabled successfully.');
            this.onRefresh();
          },
          error: (err) => {
            console.error('Error enabling customer:', err);
            this.ns.showError('Error', 'Failed to enable customer.');
          },
          complete: () => {
            this.enablingCustomer = false;
          }
        });
      },
      reject: () => {}
    });
  }
}
